<div>
    <i class="pi pi-exclamation-triangle"></i>
    This will take all associated quote requests, quotes, work orders, surveys, and customer notes from the Source customer and merge them into the Target customer. 
    Only selected contacts are moved over.
</div>


<div class="combine-container">
    <div class="combine-column">
        <h6>Target</h6>
        <app-customer-dropdown (customerSelected)="setTarget($event)"></app-customer-dropdown>

        @if (targetCustomer) {
            <app-display-customer-info [customer]="targetCustomer" [canSelectContacts]="false"></app-display-customer-info>
        }
    </div>
    <div>
        <i class="pi pi-arrow-left"></i>
    </div>
    <div class="combine-column">
        <h6>Source</h6>
        <app-customer-dropdown (customerSelected)="setSource($event)"></app-customer-dropdown>

        @if (sourceCustomer) {
            <app-display-customer-info [customer]="sourceCustomer" [canSelectContacts]="true" (contactChangeEvent)="selectedContacts = $event"></app-display-customer-info>
        }
    </div>
</div>
<div style="text-align: right;">
    <p-button type="button" severity="primary" (click)="combine();" [disabled]="!canCombine || !targetCustomer || !sourceCustomer">Combine</p-button>
</div>